import { api, URLs } from '@/libs/api'
import type {
  ApiResponse,
  WeeklyNotePayload,
  WeeklyNotesData,
  WeeklyNotesParams,
} from '@/libs/interfaces'
import { IS_MOCK_MODE } from '@/libs/mocks/config'
import { weeklyNotesApiMock } from '@/libs/mocks/handlers/weeklyNotes'

const weeklyNotesApiReal = {
  getWeeklyNotes: async (params: WeeklyNotesParams): Promise<WeeklyNotesData> =>
    await api
      .get<
        ApiResponse<WeeklyNotesData>
      >(URLs.WeeklyNotes.getWeeklyNotes(params?.storeID || '', params?.week || ''))
      .then((response) => response.data?.data),

  createOrUpdateWeeklyNotes: async (payload: WeeklyNotePayload): Promise<WeeklyNotesData> =>
    await api
      .put<ApiResponse<WeeklyNotesData>>(URLs.WeeklyNotes.put(payload.storeID), {
        week: payload.week,
        weekNote: payload.weekNote,
        dailyNotes: payload.dailyNotes,
      })
      .then((response) => response.data.data),
}

export const weeklyNotesApi: typeof weeklyNotesApiReal = IS_MOCK_MODE
  ? weeklyNotesApiMock
  : weeklyNotesApiReal
